// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';

import BulkOperationFileSelector from 'ion-experimental/app/shared/bulk-operations/BulkOperationFileSelector';

export default function FileSelector({ onFileSelect, pipelineCount, hasError, errorMessage, selectedFile }) {
  return (
    <BulkOperationFileSelector
      description="Upload a YAML file containing pipeline configurations. Each pipeline will be created with the specified name, writekey, and cluster assignment."
      selectedFile={selectedFile}
      itemCount={pipelineCount}
      itemLabel="Pipelines"
      onFileSelect={onFileSelect}
      hasError={hasError}
      errorMessage={errorMessage}
      testId="bulk-create-file-input"
    />
  );
}

FileSelector.propTypes = {
  onFileSelect: PropTypes.func.isRequired,
  pipelineCount: PropTypes.number.isRequired,
  hasError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  selectedFile: PropTypes.object,
};
